const { SUBSCRIBER_TYPE } = require('../delivery-saver.constants');

class DeliverySaverPlanSelectionController {

    constructor(
        $state,
        $q,
        settings,
        deliverySaverService,
        shopperService,
    ) {
        this.$state = $state;
        this.$q = $q;
        this.deliverySaverService = deliverySaverService;
        this.shopperService = shopperService;

        this.enableSeniorPlans = settings.deliverySaver.enableSeniorPlans;
        this.allowB2BToSubscribe = settings.deliverySaver.allowB2BToSubscribe;

        this.SUBSCRIBER_TYPE = SUBSCRIBER_TYPE;
        this.selectedSubscriberType = SUBSCRIBER_TYPE.PERSONAL;
        this.isLoading = true;
        this.hasLoadPlansError = false;

        this.hasActiveDeliveryPass = false;
        this.hasActiveDeliverySaver = false;
        this.hasSuspendedDeliverySaver = false;
        this.isBusinessAccount = false;
    }

    $onInit() {
        this.deliverySaverService.verifyDeliverySaverIsAvailable();

        this.personalPlansNotEligible = this.$state.params.personalPlansNotEligible;
        this.businessPlansNotEligible = this.$state.params.businessPlansNotEligible;
        this.seniorPlansNotEligible = this.$state.params.seniorPlansNotEligible;

        this.$q.all([
            this.getEligibility(),
            this.getPlans(),
        ]).then(([_, plans]) => {
            this.isLoading = false;
            this.plans = plans;
            this.selectedSubscriberType = this.getDefaultSelectedSubscriberType();
        });
    }

    getDefaultSelectedSubscriberType() {
        if (this.isBusinessAccount) {
            return SUBSCRIBER_TYPE.BUSINESS;
        }

        if (this.isEligibleForSeniorPlan) {
            return SUBSCRIBER_TYPE.SENIOR;
        }

        return SUBSCRIBER_TYPE.PERSONAL;
    }

    isToggleVisible() {
        if (this.shopperService.IsGuest) {
            return this.allowB2BToSubscribe || this.enableSeniorPlans;
        }

        if (this.isBusinessAccount) {
            return this.allowB2BToSubscribe;
        }

        return this.allowB2BToSubscribe || this.enableSeniorPlans;
    }

    isEligibleToSubscribeBySubscriberType() {
        if (this.hasActiveDeliveryPass) {
            return false;
        }

        if (this.hasSuspendedDeliverySaver) {
            return false;
        }

        if (this.hasActiveDeliverySaver) {
            return false;
        }

        if (this.shopperService.IsGuest) {
            return true;
        }

        switch (this.selectedSubscriberType) {
            case SUBSCRIBER_TYPE.PERSONAL:
                return !this.isBusinessAccount;

            case SUBSCRIBER_TYPE.SENIOR:
                if (!this.enableSeniorPlans) {
                    return false;
                }

                if (!this.isEligibleForSeniorPlan) {
                    return false;
                }

                return !this.isBusinessAccount;

            case SUBSCRIBER_TYPE.BUSINESS:
                if (!this.allowB2BToSubscribe) {
                    return false;
                }

                return this.isBusinessAccount;

            default:
                return false;
        }
    }

    getEligibility() {
        return this.deliverySaverService.getEligibility()
            .then((response) => {
                this.dateEligibleForDeliverySaver = response.DateEligibleForDeliverySaver;
                this.hasActiveDeliveryPass = response.HasActiveDeliveryPass;
                this.hasActiveDeliverySaver = response.HasActiveDeliverySaver;
                this.hasSuspendedDeliverySaver = response.HasSuspendedDeliverySaver;
                this.isBusinessAccount = response.IsBusinessAccount;
                this.isEligibleForDeliverySaver = response.IsEligibleForDeliverySaver;
                this.isEligibleForSeniorPlan = !response.HasActiveDeliverySaver && response.IsEligibleForSeniorPlan;
            });
    }

    getPlans() {
        // Returns 403 when the delivery saver setting is disabled
        return this.deliverySaverService.listPlans()
            .then(response => response.Plans)
            .catch(() => {
                this.hasLoadPlansError = true;
            });
    }
}

DeliverySaverPlanSelectionController.$inject = [
    '$state',
    '$q',
    'Settings',
    'DeliverySaverService',
    'ShopperService',
];

const DeliverySaverPlanSelectionComponentDefinition = {
    controller: DeliverySaverPlanSelectionController,
    template: require('./delivery-saver-plan-selection.component.html').trim(),
};

module.exports = {
    DeliverySaverPlanSelectionController,
    DeliverySaverPlanSelectionComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/deliverysaver/planselection/delivery-saver-plan-selection.component.js